/**
 * You should now be able to simply use the jvSelect2 directive and associated attributes to configure the Select2.
 * The old jvSelectfilter directive should be maintained here for backwards-compatibility until we replace it.
 * 
 * usage:   <div 
 *              jv-Select2="jv-select2id" 
 *              jv-Select2-placeholder='Generic placeholder' 
 *              jv-Select2-data='<some scope-level array of objects: {id: value, text: text}>'
 *              jv-Select2-value='<some scope-level value object>'>
 *          </div>
 * 
 * Even handles late-binding of data (like if it must be populated from results of an AJAX call).
 * 
 */
angular.module("AppCtrl.select2.directive",['AppCtrl.select2.service'])

    .directive("jvSelect2", function() {
        return {
            restrict: 'A',
            link: function(scope, element, attr) {
                
                var backingData = {};
                
                var hiddenField = angular.element("<input type=\"hidden\" id=\"" + attr.jvSelect2 + "\" />");
                element.append(hiddenField);

                scope.$watch('data', function(val) {
                    if (!angular.isDefined(val)) {
                        return;
                    }
                    backingData = {};
                    angular.forEach(val, function(backingDataValue) {
                        backingData[backingDataValue.id] = backingDataValue;
                    });

                    $(hiddenField).select2({
                        placeholder: attr.jvSelect2Placeholder,
                        allowClear: true,
                        data:scope.data,
                        initSelection: function(elem,callback){
                            callback({text:elem.val()});
                        }
                    }).on('change', function(e) {
                        if (e.val !== scope.value) {
                            scope.$apply("value = \"" + e.val + "\"");
                        }
                    })
                    });
                scope.$watch('value', function(val) {
                    if(!angular.isDefined(val) || $(hiddenField).select2("val") === val) {  // We have been changed by UI
                        return;
                    } else {
                        $(hiddenField).select2("data", backingData[val]);
                    }
                });
            },
            scope: {
                data: '=jvSelect2Data',
                value: '=jvSelect2Value'
            }
        };
    })
    .directive('jvCustomNgmodel', ["$compile", "$rootScope", "returnObjectForId",function($compile, $rootScope, returnObjectForId ){
        return {
            restrict: 'A', // only activate on element attribute
            require: '?ngModel', // get a hold of NgModelController
            link: function(scope, element, attr, ngModel){
                if(!ngModel) return;
    
                // Called when the view needs to be updated.
                ngModel.$render = function(){
                    var _callback = function(dataObject){
                        $(element).select2("data",dataObject);
                    } 
                    //ngModel.$viewValue reads the value from the javascript so that it can be reflected in the UI now.
                    var dataObject = returnObjectForId(ngModel.$viewValue, _callback);
                };
    
                //VA: angular binding is not working?       
    //          element.bind('change', function(){
    //              scope.$apply( read );
    //          });
    
                // When the ui changes it fires the change event.
                if (jQuery.fn.jquery.split('.')[0] === '3') {
                    $(element).on('change', function(){
                        scope.$apply( setValue );
                    });
                } else {
                    $(element).bind('change', function(){
                        scope.$apply( setValue );
                    });
                }
                
                setValue();
                //sets the value of the ng-model
                function setValue( ){
                    ngModel.$setViewValue(element.val());
                };
                }
            }
    }]).
    /**
     * Renders the select2
     * @param {Object} jvformatResult: service for fomatting the results returned.
     * @param {Object} jvformatSelection: service for fomatting the selected dropdown
     * @param {Object} jvid: service for setting the id 
     * @param {Object} $compile: compiler
     */
    directive('jvSelectfilter', ['jvformatResult', 'jvformatSelection','jvid', '$compile', function( jvformatResult, jvformatSelection, jvid, $compile ){
        var directiveObj = {
            restrict: 'A',
            replace: true,
            scope:{
                identifier: '@identifier',
                // flag is for identifying if the data is local or will be received from the ajax call.
                url: '@ajaxurl'
            },
            template: "<div>"+
                        "<input jv-custom-ngmodel type='text' style='width:200px; max-width: 200px;' type='hidden' />"+
                    "</div>",
            compile: function compile(tElement, tAttrs, transclude) {
                var me = this;
                var _resultsCacher = {
                    previousWord: "",
                    previousResultReturned: 0,
                    isStale: false
                };
                
                return {
                    pre: function preLink(scope, iElement, iAttrs, controller) {
                        var childElement = angular.element(iElement.children()[0]);
                        // add the parent scope or the isolated scope.
                        angular.element(childElement).attr("ng-model", !!iAttrs.ngModelparentRef?iAttrs.ngModelparentRef:iAttrs.ngModelRef);
                        
                    },
                    post: function postLink(scope, iElement, iAttrs, controller) {
                        var childElement = angular.element(iElement.children()[0]);
                        //i18n object will be defined and initialize in source_kono_layout.jsp (header JSP)
                        var checkStaleCondition = function(args){
                            try{
                                if(_resultsCacher.previousWord && _resultsCacher.previousWord.trim() !="" && args.data.q.indexOf(_resultsCacher.previousWord,0 ) != -1 && _resultsCacher.previousResultReturned == 0){
                                    _resultsCacher.isStale = true;
                                    return true;
                                    
                                }
                            }catch(e){
                                // if something goes wrong just send the request in any case.
                                previousWord = "";
                                previousResultReturned = 0;
                                _resultsCacher.isStale = false;
                                return false;
                            }
                            
                        };
                        $(childElement).select2($.extend({}, window._jvPluginDefaults.select2, {
                            placeholder: iAttrs.jvSelectPlaceholder || (i18n && i18n.ALL) || "All",
                            allowClear: true,
                            minimumInputLength: 1,
                            formatResult: function( state ){
                                return jvformatResult(state);
                            },
                            id: function(state){
                                return jvid(state);
                            },
                            formatSelection: function(state){
                                return jvformatSelection(state);
                            },
                            ajax: {
                                transport: function(args){
                                    //VA: Can not keep on making call to the backend if there are no results. This is the optimization to stop irrelevant calls to the backend.
                                    try{
                                        if(checkStaleCondition(args)){
                                            return null;
                                        }
                                    }catch(e){
                                    }
                                    _resultsCacher.previousWord = args.data.q;
                                    return $.ajax(args);
                                },
                                url: iAttrs.ajaxurl,
                                dataType: 'json',
                                // object that backend needs
                                data: function( term ){
                                    return {
                                        action: iAttrs.actiontype,
                                        pageSize: iAttrs.pagesize,
                                        q: term
                                    };
                                },
                                results: function(data){
                                    _resultsCacher.previousResultReturned = data.employees.length;
                                    if( _resultsCacher.previousResultReturned == 0){
                                        _resultsCacher.isStale = true;
                                    }
                                    
                                    //VA: It should be a service instead of hardcoding the value here.
                                    return {results: data.employees};
                                }
                            }
                        }));
                        if(typeof iAttrs["ngModelparentRef"] != "undefined"){
                            // if the model doesnt need an isolated scope it should be bounded to the parent scope. For filters
                            $compile(iElement.contents())(scope.$parent);
                        }else{
                            
                            $compile(iElement.contents())(scope.$parent);
                        }
                    }
            }
            }
        }
        return directiveObj;
    }]);


angular.module("AppCtrl.jobvite.directive",["AppCtrl.select2.directive"])
    .directive("jvProcessing", function() {
        return {
            compile: function(tElement, tAttrs) {
                var processingWindow = angular.element("<div class='jqDnR jqmWindow'></div>");
                tElement.prepend(processingWindow);
                var content = angular.element('<center><img src="/__assets__/images/ajax-loader.gif" style="padding-top: 50%"/></center>');
                $(processingWindow).html(content);
                $(processingWindow).css("display", "none");
                processingWindow.css({"top":"","left":""});
                $.jqm.params.modal = true;
                $(processingWindow).jqm( );       // initialization.

                return function(scope, element, attrs) {
                    scope.$watch('showProcessingWindow', function(val) {
                        if(val) {
                            $(processingWindow).jqmShow();
                            $(processingWindow).css("display", "block");
                        } else {
                            $(processingWindow).jqmHide();
                        }
                    });
            }
            }
        };

    });